module.exports = __webpack_public_path__ + "static/assets/874e7dd6003137b73a9fbbdc7e34a27d.png";